import { getLoincLabDisplayName } from '@liza/fhir-utils';

/**
 * What to call a reading coded a sibling of the code its row tracks — a clinic weight on a body-weight
 * row, a glucometer reading on a blood-glucose row.
 *
 * The curated display map holds the codes a plan tracks, not the siblings a reading arrives under — it
 * names `2339-0` and `4548-4`, but nothing for `3141-9`, `8331-1`, `41653-7` or `17856-6`. So for a
 * variant the reading's own display is in practice the only name there is, and an imported one always
 * carries one. Returns undefined when neither names it, so the caller drops the line rather than
 * printing a bare LOINC code.
 */
export const resultVariantLabel = (code: string | undefined, codeDisplay: string | undefined): string | undefined =>
  code ? (getLoincLabDisplayName(code) ?? codeDisplay) : undefined;
